export const REDUCER_NAME = 'SEND_MANAGE_CAMPAIGNS';


